import * as React from 'react'

import { APPS } from 'modules/billing/lib/types'
import type SubscriptionAddon from 'modules/billing/store/models/SubscriptionAddon'

import UninstallAddon from './UninstallAddon'
import UninstallAts from './UninstallAts/UninstallAts'
import UninstallShiftManagement from './UninstallShiftManagement'

interface Props {
  subscriptionAddon: SubscriptionAddon
  onSubmit: () => void
  onClose: () => void
}

export const UninstallModal = ({ subscriptionAddon, onSubmit, onClose }: Props) => {
  switch (subscriptionAddon.attributes.id) {
    case APPS.shift_management:
      return <UninstallShiftManagement onSubmit={onSubmit} onClose={onClose} />
    case APPS.ats:
      return <UninstallAts onSubmit={onSubmit} onClose={onClose} />

    default:
      return (
        <UninstallAddon
          onSubmit={onSubmit}
          onClose={onClose}
          subscriptionAddon={subscriptionAddon}
        />
      )
  }
}
